import { Node } from '@tiptap/core';
import { resolveLetterImageDocInsertPos } from './letterImageInsertion.js';

export const LETTER_TEMPLATE_IMAGE_WIDTH_MIN = 10;
export const LETTER_TEMPLATE_IMAGE_WIDTH_MAX = 100;
export const LETTER_TEMPLATE_IMAGE_ALT_MAX = 200;
export const LETTER_TEMPLATE_MAX_IMAGE_NODES = 6;

export const LetterImageExtension = Node.create({
  name: 'letterImage',
  group: 'block',
  atom: true,
  selectable: true,
  draggable: false,

  addAttributes() {
    return {
      assetId: { default: null },
      widthPct: { default: 50 },
      align: { default: 'center' },
      alt: { default: '' },
    };
  },

  parseHTML() {
    return [{ tag: 'div[data-letter-image]' }];
  },

  renderHTML({ node, HTMLAttributes }) {
    const align = node.attrs.align || 'center';
    const widthPct = Number(node.attrs.widthPct) || 50;
    return [
      'div',
      {
        ...HTMLAttributes,
        'data-letter-image': 'true',
        'data-asset-id': node.attrs.assetId || '',
        class: 'letter-image-block',
        style: `text-align: ${align}; width: ${widthPct}%`,
      },
      '',
    ];
  },

  addCommands() {
    return {
      insertLetterImage:
        (attrs) =>
        ({ state, dispatch, tr }) => {
          const insertPos = resolveLetterImageDocInsertPos(state.selection);
          if (insertPos == null) return false;
          const imageNode = state.schema.nodes.letterImage.create({
            assetId: attrs.assetId,
            widthPct: attrs.widthPct ?? 50,
            align: attrs.align ?? 'center',
            alt: attrs.alt ?? '',
          });
          if (dispatch) {
            dispatch(tr.insert(insertPos, imageNode).scrollIntoView());
          }
          return true;
        },
      updateLetterImageAttrs:
        (attrs) =>
        ({ commands }) =>
          commands.updateAttributes(this.name, attrs),
    };
  },
});

export default LetterImageExtension;
